


































































































import {Vue, Component, Ref, Watch} from 'vue-property-decorator';
import {namespace} from 'vuex-class';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import type {GetMainMenus, Mall, AppsAppNoInstalledMalls, Nullable} from 'ncp-api-supporter';
import {Admin} from '@/types';
import { I18N_LOCALE, LEFT_MENU_FLG } from '@/const/words/cookie';
import Cookies from 'js-cookie';
import GnbWrap from '@/components/header/GnbWrap.vue';
import ManageAccount from '@/components/header/ManageAccountIframe.vue';
import PasswordUpdate from '@/components/header/PasswordUpdate.vue';
import ProfileSetting from '@/components/header/ProfileSetting.vue';
import Logo from '@/components/common/Logo.vue';
import ClickOutside from 'vue-click-outside';
import { logout } from '@/utils/authUtils';
import { openProAdminContentsPopup } from '@/utils/commonUtils';
import { excludePath, executeApp } from './gnbWrap';
import {State, Mutation} from 'vuex-class';
import DesignEditorButtonGroup from './DesignEditorButtonGroup.vue';
import  MallSelectionModal  from './MallSelectionModal.vue'
import { sendTokenPostMessage } from '../iframe/util';

const adminModule = namespace('admin');
const mallModule = namespace('mall');
const { VUE_APP_COMMERCE_AUTH } = process.env

@Component({
  components: { Logo, CompSelectBox, DesignEditorButtonGroup, GnbWrap, ManageAccount, PasswordUpdate, ProfileSetting, MallSelectionModal},
  directives: {
    ClickOutside,
  },
})
export default class Headers extends Vue {
  // * vuex
  @adminModule.Getter('admin') private admin!: Admin;
  @adminModule.Getter('menuGroups') private menuGroups!: GetMainMenus[];
  @mallModule.State('malls') private stateMalls!: Mall[];
  @mallModule.Action('fetchMalls') private fetchMalls!: () => Promise<any>;
  @adminModule.Getter('isCommerceAccount') private readonly isCommerceAccount: boolean;
  @adminModule.Action('setCommerceAccount')
  private setCommerceAccount: (isCommerceAccount: boolean) => void;

  @State private onGnb!: boolean;
  @Mutation('SET_ONGNB') private setOnGnb!: (isOpen: boolean) => void;

  // * data
  private onSitemap = false;
  private onProfileMenu = false;
  private showAccount = false;
  private showPwdChange = false;
  private showSetting = false;
  private show = false;
  private selectedAppNo: number = 0;
  private appInstalledMalls: Nullable<AppsAppNoInstalledMalls[]> = null;
  private kakaoFriendAppNo = process.env.VUE_APP_KAKAO_FRIENDS_APP_NO;
  private remoteUrl = `${process.env.VUE_APP_ADMIN_REMOTE_URL}?serviceType=PREMIUM`;

  @Ref()
  private iFrame: HTMLIFrameElement;

  private get badgeUrl() {
    return require(this.admin.plan === 'STANDARD' ? '@/assets/img/badge_standard.png' : '@/assets/img/badge.png');
  }

  get malls() {
    return [{mallNo: 0, mallName: '쇼핑몰'}, ...this.stateMalls];
  }

  private get showMenus() {
    if (this.menuGroups) {
      const showMenuGroups = [];
      this.menuGroups.forEach((group) => {
        if (group.displayable) {
          const menus = group.menus.filter((item) => item.displayable);
          showMenuGroups.push({
            name: group.name,
            order: group.order,
            menus
          });
        }
      });
      return showMenuGroups;
    }
  }

  @Watch('stateMalls')
  private get showDesignEditorButtons() {
    return this.stateMalls.some(({ planType }) => planType === 'STANDARD');
  }

  private created() {
    this.onSitemap = false;
    this.onProfileMenu = false;
    this.fetchManagerInfo();
    this.setOnGnb(Cookies.get(LEFT_MENU_FLG) === 'open');
  }

  private async fetchManagerInfo() {
    const { data } = await this.$api.getManagerInfo();
    this.setCommerceAccount(data.commerceAccount);
  }

  // * lifecycle
  private async mounted() {
    this.iFrame.onload = () => {
      sendTokenPostMessage(this.iFrame);
    }
    window.addEventListener('keydown', this.escapeHeaderElements);
    let i18nLocale = Cookies.get(I18N_LOCALE);
    if (!i18nLocale) {
      const request: any = {
        params: {
          searchType: 'ADMIN_ID',
          keyword: this.admin.id
        }
      };

      i18nLocale = 'kr';
      const {data} = await this.$api.getAdminsService(request);
      const myAdmin = data.contents.find((tempAdmin) => tempAdmin.adminId === this.admin.id);
      if (myAdmin) {
        switch (myAdmin.language) {
          case 'CHINESE':
            i18nLocale = 'zh';
            break;
          case 'JAPANESE':
            i18nLocale = 'jp';
            break;
          case 'ENGLISH':
            i18nLocale = 'en';
            break;
          default:
            i18nLocale = 'kr';
            break;
        }
      }
      Cookies.set(I18N_LOCALE, i18nLocale);
    }
    this.$i18n.locale = i18nLocale;
  }

  private beforeDestroy(): void {
    window.removeEventListener('keydown', this.escapeHeaderElements);
  }

  // * method

  // esc key event
  private escapeHeaderElements(event: KeyboardEvent): void {
    if (event.key == 'Escape') {
      this.onSitemap = false;
      this.onProfileMenu = false;
      this.showAccount = false;
      this.showPwdChange = false;
      this.showSetting = false;
    }
  }

  private async logoutInternal() {
    await logout();
  }

  private changePassword() {
    this.isCommerceAccount ? window.open(`${VUE_APP_COMMERCE_AUTH}/mypage/change-password`, '_self') : this.showPwdChange = true;
 }

  private clickSiteMap(): void {
    this.onProfileMenu = false;
    this.onSitemap = !this.onSitemap;
  }

  private clickProfileMenu(): void {
    this.onProfileMenu = !this.onProfileMenu;
    this.onSitemap = false;
  }

  private clickMenu(menu: GetMainMenus): void {
    this.onSitemap = false;
    if (menu.readable) {
     if(menu.uri.includes('/premium') && !excludePath.includes(menu.uri)) {
        openProAdminContentsPopup(menu.uri);
        return;
      }
      if(!!menu.appNo){
        this.handleAppSelect(menu.appNo);
        return;
      }
      this.$router.push(menu.uri).catch(() => location.reload());
      // window.location.href = menu.uri;
    } else {
      alert(this.$t('PAGE_WRITABLE_NONE'));
    }
  }


  private async handleAppSelect(appNo: number) {
    this.selectedAppNo = appNo;

    const { data: appInfo } = await this.$api.getAppsAppNoInstalledMalls({ pathParams: { appNo } })

    if (appInfo.length > 1) {
      this.appInstalledMalls = appInfo;
    } else {
      executeApp(appNo, appInfo?.at(0) ?? null);
    }
  }

  private goMain() {
    window.location.href = '/';
  }

  onClickOutside(): void {
    this.show = false;
  }

  private clickGnb() {
    this.setOnGnb(!this.onGnb);
  }
}
